import { render, staticRenderFns } from "./TopHeader.vue?vue&type=template&id=0545dc4a&scoped=true"
import script from "./TopHeader.vue?vue&type=script&lang=js"
export * from "./TopHeader.vue?vue&type=script&lang=js"
import style0 from "./TopHeader.vue?vue&type=style&index=0&id=0545dc4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0545dc4a",
  null
  
)

export default component.exports